import { ThemeProvider as StylesThemeProvider } from '@mui/styles';
import type { Theme } from '@ori-ui/mui';
import { ThemeProvider, StyledEngineProvider, theme } from '@ori-ui/mui';
import i18next from 'i18next';
import type { VFC } from 'react';
import React, { Suspense, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';

import { clientProvider } from '../api/ClientProvider';
import { NotifyPopup } from '../components/NotifyPopup/NotifyPopup';
import { AppContextProvider } from '../contexts';
import type { NotifyMePopupConfig } from '../models';
import { ErrorBoundary } from './ErrorBoundary/ErrorBoundary';

declare module '@mui/styles' {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface -- needed
    interface DefaultTheme extends Theme {}
}

export const BackInStockNotificationApp: VFC<NotifyMePopupConfig> = ({ translations, ...restConfig }) => {
    i18next.init({
        lng: 'default',
        resources: {
            default: {
                translation: translations ?? {},
            },
        },
        keySeparator: '::',
    });

    useEffect(() => {
        clientProvider.init(restConfig);
    }, [restConfig]);

    return (
        <ErrorBoundary>
            <Suspense fallback={null}>
                <I18nextProvider i18n={i18next}>
                    <StyledEngineProvider injectFirst>
                        <StylesThemeProvider theme={theme}>
                            <ThemeProvider enableCacheProvider cacheKey="back-in-stock-notification">
                                <AppContextProvider {...restConfig}>
                                    <NotifyPopup />
                                </AppContextProvider>
                            </ThemeProvider>
                        </StylesThemeProvider>
                    </StyledEngineProvider>
                </I18nextProvider>
            </Suspense>
        </ErrorBoundary>
    );
};
